import {
  PERKS_REDIRECT_URL_KEY,
  PERKS_SIGNUP_RESULT_KEY,
  PERKS_SIGNUP_ERROR_KEY,
  NEW_MEMBER_SIGNUP,
  PREVIOUS_MEMBER_SIGNUP,
  PERKS_WAS_COLLECTION_REDIRECTED_KEY,
  PERKS_RESPONSE_SEEN_ON_PF_KEY,
} from './constants';
import { PERKS_EVENT } from '../../../contexts/ShopifyCustomerProvider';

export const getPerksCollectionUrl = () => window.Jbhifi?.perksCollectionUrl || '/';

export const getPerksRedirectDestination = () => localStorage.getItem(PERKS_REDIRECT_URL_KEY);

export const setPerksRedirectDestination = (url: string) => localStorage.setItem(PERKS_REDIRECT_URL_KEY, url);

export const getPerksWasCollectionRedirected = () =>
  localStorage.getItem(PERKS_WAS_COLLECTION_REDIRECTED_KEY) === 'true';

export const setPerksWasCollectionRedirected = (value: boolean) =>
  localStorage.setItem(PERKS_WAS_COLLECTION_REDIRECTED_KEY, value ? 'true' : 'false');
export const setPerksSignupError = (error: string) => localStorage.setItem(PERKS_SIGNUP_ERROR_KEY, error);

export const signalShopifyCustomerProvidersIsPerksTrue = () => {
  window.dispatchEvent(new CustomEvent(PERKS_EVENT, { detail: { isPerks: true } }));
};

export const checkIsPerksRedirectSetAndNavigate = () => {
  const perksRedirectUrl = getPerksRedirectDestination();
  if (perksRedirectUrl) {
    setTimeout(() => (window.location.href = perksRedirectUrl), 1500);
    return true;
  }
  return false;
};

export const setPerksSubscribeSuccessful = ({
  returningMember,
  wasPreviousMember,
}: {
  returningMember?: boolean;
  wasPreviousMember: boolean;
}) => {
  if (returningMember) return;
  localStorage.setItem(PERKS_SIGNUP_RESULT_KEY, wasPreviousMember ? PREVIOUS_MEMBER_SIGNUP : NEW_MEMBER_SIGNUP);
};

export const wasPerksPageflyPageViewed = () => {
  if (localStorage.getItem(PERKS_RESPONSE_SEEN_ON_PF_KEY) === 'true') {
    localStorage.removeItem(PERKS_RESPONSE_SEEN_ON_PF_KEY);
    return true;
  }
  return false;
};

export const checkPerksSignupResult = (shouldIgnore: boolean) => {
  const resetState = () => {
    localStorage.removeItem(PERKS_REDIRECT_URL_KEY);
    localStorage.removeItem(PERKS_SIGNUP_ERROR_KEY);
    localStorage.removeItem(PERKS_SIGNUP_RESULT_KEY);
    localStorage.removeItem(PERKS_RESPONSE_SEEN_ON_PF_KEY);
  };
  if (shouldIgnore) {
    resetState();
    return;
  }
  const signupResult = localStorage.getItem(PERKS_SIGNUP_RESULT_KEY);
  const signupError = localStorage.getItem(PERKS_SIGNUP_ERROR_KEY);
  if (signupResult || signupError) {
    const path = window.location.pathname;
    if (!path.includes('/pages/') || path.includes('-perks')) {
      resetState();
    } else {
      localStorage.setItem(PERKS_RESPONSE_SEEN_ON_PF_KEY, 'true');
    }
    if (signupError) return signupError;
    window.Jbhifi.customerDetails ??= {};
    window.Jbhifi.customerDetails.isPerks = true;
    signalShopifyCustomerProvidersIsPerksTrue();
    return signupResult;
  }
  return false;
};

const getPerksReferrerUrl = (isCustomerPerks?: boolean) => {
  let referrer = document.referrer;
  if (referrer) {
    const referrerUrl = new URL(referrer);
    const referrerHost = referrerUrl.host;
    const referrerPath = referrerUrl.pathname;
    const isReferrerJbhifi = referrerHost.endsWith('jbhifi.com.au');
    if (!isReferrerJbhifi) referrer = isCustomerPerks ? getPerksCollectionUrl() : '/account';
    if (isCustomerPerks && referrerPath === '/') referrer = getPerksCollectionUrl();
  } else {
    if (isCustomerPerks) referrer = getPerksCollectionUrl();
  }
  return referrer ? referrer : '/account';
};

export const setPerksLandingReturnUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const isCustomerPerks = window.Jbhifi?.customerDetails?.isPerks;
  const shouldPerformRedirect = params.get('redirect') === 'true';
  const referrer = params.get('returnUrlOverride') || getPerksReferrerUrl(isCustomerPerks);
  if (shouldPerformRedirect) {
    if (isCustomerPerks) {
      if (!checkIsPerksRedirectSetAndNavigate()) {
        window.location.replace(referrer);
      }
    } else {
      setPerksRedirectDestination(referrer);
    }
  } else {
    localStorage.removeItem(PERKS_REDIRECT_URL_KEY);
  }
};
